export const environment = {
  production: false,
  baseApi: 'https://portaltest.afraway.org/api/',
  showCampaignBanner: true
}
